import type { SxProps, Theme } from '@mui/material';
import { TEXT_DARK } from '../../../styles/GlobalStyles';

export const subscriptionFeatureStyles = {
  container: (theme: Theme) => ({
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '50px 15px',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.paper,
    color: TEXT_DARK,
    fontFamily: theme.typography.fontFamily,
    fontSize: '20px',
    lineHeight: 1.42857143,
    textAlign: 'center',
  }) satisfies SxProps<Theme>,

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '15px',
    marginBottom: '50px',
  } satisfies SxProps<Theme>,

  icon: {
    width: '60px',
    height: '60px',
    flexShrink: 0,
    fill: '#FFFFFF',
  } satisfies SxProps<Theme>,

  heading: (theme: Theme) => ({
    margin: 0,
    color: theme.palette.primary.main,
    fontFamily: 'inherit',
    fontSize: '24px',
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: 'inherit',
  }) satisfies SxProps<Theme>,

  content: {
    width: { xs: '100%', sm: '66.666667%' },
    margin: '0 auto',
  } satisfies SxProps<Theme>,

  description: {
    margin: '0 0 15px',
    fontFamily: 'Handwritten, monospace',
    fontSize: '24px',
    lineHeight: 'inherit',
    whiteSpace: 'pre-line',
  } satisfies SxProps<Theme>,

  example: {
    marginBottom: '15px',
  } satisfies SxProps<Theme>,

  image: {
    display: 'block',
    maxWidth: '100%',
    height: 'auto',
    margin: '0 auto',
    objectFit: 'contain',
  } satisfies SxProps<Theme>,

  profileGuidance: {
    margin: '0 0 15px',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
  } satisfies SxProps<Theme>,

  link: {
    display: 'block',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
  } satisfies SxProps<Theme>,

  action: (theme: Theme) => ({
    color: theme.palette.primary.dark,
    '&:focus-visible, &.Mui-focusVisible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '2px',
    },
  }) satisfies SxProps<Theme>,
};
